import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm mt-8" }
const _hoisted_2 = { class: "px-6" }
const _hoisted_3 = {
  key: 0,
  class: "mb-6 rounded-md border border-border bg-muted/10 p-4"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "grid gap-6 md:grid-cols-2" }
const _hoisted_6 = ["aria-invalid"]
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_8 = ["aria-invalid"]
const _hoisted_9 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_10 = ["aria-invalid"]
const _hoisted_11 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_12 = ["aria-invalid"]
const _hoisted_13 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_14 = ["aria-invalid"]
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_16 = ["aria-invalid"]
const _hoisted_17 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_18 = { class: "flex justify-between items-center px-6 pt-6" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { key: 1 }

import { ref, watch, computed, nextTick } from 'vue'
import { Loader2 } from 'lucide-vue-next'
import { useCompanyRegistrationStore } from '@/stores/companyRegistrationStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagerInformationStep',
  props: {
    data: {},
    isSaving: { type: Boolean }
  },
  emits: ['update', 'back', 'submit'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const registrationStore = useCompanyRegistrationStore()
// Password and password confirm are local values not sent to the store and only attached if the user submits
const password = ref('')
const passwordConfirm = ref('')



const localData = ref({ ...props.data })
const errors = ref<Record<string, string>>({})

const managerOptions = computed(() => {
  const source = registrationStore.form?.keyPeople ?? []
  return source
    .map((person: any, index: number) => {
      const firstName = (person?.firstName ?? '').trim()
      const lastName = (person?.lastName ?? '').trim()
      const role = (person?.role ?? '').trim()
      if (!firstName || !lastName || !role) return null
      return {
        value: String(index),
        firstName,
        lastName,
        role,
        label: `${firstName} ${lastName} (${role})`,
      }
    })
    .filter(
      (item): item is {
        value: string
        firstName: string
        lastName: string
        role: string
        label: string
      } => item !== null
    )
})

const selectedManagerSource = ref('custom')
let isApplyingSelection = false

const syncSelectionFromData = () => {
  const currentFirst = (localData.value.firstName ?? '').trim()
  const currentLast = (localData.value.lastName ?? '').trim()
  const currentRole = (localData.value.jobTitle ?? '').trim()

  const matched = managerOptions.value.find(
    (option) =>
      option.firstName === currentFirst &&
      option.lastName === currentLast &&
      option.role === currentRole
  )

  selectedManagerSource.value = matched ? matched.value : 'custom'
}

watch(
  managerOptions,
  () => {
    syncSelectionFromData()
  },
  { immediate: true }
)

watch(selectedManagerSource, async (value) => {
  if (value === 'custom') return
  const option = managerOptions.value.find((item) => item.value === value)
  if (!option) {
    selectedManagerSource.value = 'custom'
    return
  }

  isApplyingSelection = true
  localData.value.firstName = option.firstName
  localData.value.lastName = option.lastName
  localData.value.jobTitle = option.role
  await nextTick()
  isApplyingSelection = false
})

const handleManagerFieldInput = () => {
  if (isApplyingSelection) return
  if (selectedManagerSource.value !== 'custom') {
    selectedManagerSource.value = 'custom'
  }
}

watch(localData, (val) => emits('update', val), { deep: true })

const validateAndSubmit = () => {
  const newErrors: Record<string, string> = {}

  // Basic required fields
  if (!localData.value.firstName?.trim())
    newErrors.firstName = 'First name is required'
  if (!localData.value.lastName?.trim())
    newErrors.lastName = 'Last name is required'
  if (!localData.value.jobTitle?.trim())
    newErrors.jobTitle = 'Job title is required'
  if (!localData.value.phoneNumber?.trim())
    newErrors.phoneNumber = 'Phone number is required'

  // Password validation
  if (!password.value?.trim()) {
    newErrors.password = 'Password is required'
  } else if (password.value.length < 8) {
    newErrors.password = 'Password must be at least 8 characters'
  }

  // Confirm password match
  if (passwordConfirm.value !== password.value) {
    newErrors.confirmPassword = 'Passwords do not match'
  }

  errors.value = newErrors

  if (Object.keys(newErrors).length === 0) {
    emits('submit', { password: password.value, confirmPassword: passwordConfirm.value })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 pb-6" }, [
      _createElementVNode("div", { class: "leading-none font-semibold text-lg" }, "Manager Information"),
      _createElementVNode("div", { class: "text-muted-foreground text-sm" }, " We'll use this to contact your company's main representative ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (managerOptions.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Primary Manager", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedManagerSource).value = $event)),
              class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none text-sm"
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("option", { value: "custom" }, "Add new manager", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(managerOptions.value, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.value,
                  value: option.value
                }, _toDisplayString(option.label), 9, _hoisted_4))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedManagerSource.value]
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-muted-foreground mt-2" }, " Select an existing key person to prefill details or add a new company contact. ", -1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "First Name", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localData.value.firstName) = $event)),
            type: "text",
            placeholder: "John",
            onInput: handleManagerFieldInput,
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.firstName
          }, null, 40, _hoisted_6), [
            [_vModelText, localData.value.firstName]
          ]),
          (errors.value.firstName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errors.value.firstName), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Last Name", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localData.value.lastName) = $event)),
            type: "text",
            placeholder: "Smith",
            onInput: handleManagerFieldInput,
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.lastName
          }, null, 40, _hoisted_8), [
            [_vModelText, localData.value.lastName]
          ]),
          (errors.value.lastName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.value.lastName), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Job Title", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localData.value.jobTitle) = $event)),
            type: "text",
            placeholder: "Operations Manager",
            onInput: handleManagerFieldInput,
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.jobTitle
          }, null, 40, _hoisted_10), [
            [_vModelText, localData.value.jobTitle]
          ]),
          (errors.value.jobTitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(errors.value.jobTitle), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Phone Number", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localData.value.phoneNumber) = $event)),
            type: "tel",
            placeholder: "+61 400 000 000",
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.phoneNumber
          }, null, 8, _hoisted_12), [
            [_vModelText, localData.value.phoneNumber]
          ]),
          (errors.value.phoneNumber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(errors.value.phoneNumber), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Password", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((password).value = $event)),
            type: "password",
            placeholder: "Enter a secure password",
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.password
          }, null, 8, _hoisted_14), [
            [_vModelText, password.value]
          ]),
          (errors.value.password)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(errors.value.password), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block text-sm font-medium mb-1" }, "Confirm Password", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((passwordConfirm).value = $event)),
            type: "password",
            placeholder: "Re-enter your password",
            class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
            "aria-invalid": !!errors.value.confirmPassword
          }, null, 8, _hoisted_16), [
            [_vModelText, passwordConfirm.value]
          ]),
          (errors.value.confirmPassword)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.confirmPassword), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md border border-border text-sm hover:bg-muted",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('back')))
      }, " Back "),
      _createElementVNode("button", {
        class: "px-4 py-2 rounded-md bg-brand text-white text-sm font-medium flex items-center justify-center gap-2 hover:opacity-90 transition disabled:opacity-70 disabled:cursor-not-allowed",
        onClick: validateAndSubmit,
        disabled: props.isSaving
      }, [
        (props.isSaving)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_unref(Loader2), { class: "w-4 h-4 animate-spin" }),
              _cache[17] || (_cache[17] = _createElementVNode("span", null, "Registering...", -1))
            ], 64))
          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Complete Registration"))
      ], 8, _hoisted_19)
    ])
  ]))
}
}

})